module.exports = __webpack_public_path__ + "img/sun-and-planet.6dcf6741.svg";